import { render, staticRenderFns } from "./SMKDetails.vue?vue&type=template&id=60202bb2&scoped=true&"
import script from "./SMKDetails.vue?vue&type=script&lang=js&"
export * from "./SMKDetails.vue?vue&type=script&lang=js&"
import style0 from "./SMKDetails.vue?vue&type=style&index=0&id=60202bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60202bb2",
  null
  
)

export default component.exports